import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { DeviceService } from '../../_services/device.service';
import { ILanguage } from '../../_interfaces/language-selector.interface';
import { BaseFormErrorTranslateService } from '../forms/form-common-error/base-form-error-translate.service';
import { ErrorTranslateService } from '../forms/error-translate-service';
import { SdFormSelectComponent } from '../forms/form-select/form-select.component';
import { SdListComponent } from '../lists/list/list.component';

@Component({
  selector: 'sd-language-selector',
  templateUrl: './language-selector.component.html',
  standalone: true,
  imports: [
    SdListComponent,
    SdFormSelectComponent,
    TranslateModule
  ],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
export class SdLanguageSelectorComponent implements OnDestroy, OnInit {
  constructor(
    private cdRef: ChangeDetectorRef,
    private deviceService: DeviceService,
  ) {}

  deviceSubscription: Subscription;
  isDevice$: boolean;

  @Input()
  activeIsoCode: string;

  @Input()
  languages: ILanguage[];

  @Input()
  hasPipe: boolean;

  @Input()
  isFocusable = true;

  @ViewChild('languageSelector')
  languageSelector: SdFormSelectComponent<string>;

  @Output()
  languageSelected = new EventEmitter<string>();

  ngOnInit() {
    this.deviceSubscription = this.deviceService.isDevice.subscribe((x) => {
      this.isDevice$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.deviceSubscription?.unsubscribe();
  }

  changeLanguage(value?: ILanguage) {
    if (value) {
      this.languageSelected.emit(value.isoCode);
    } else {
      if (this.languageSelector) {
        this.languageSelected.emit(this.languageSelector.internalField.value);
      }
    }
  }
}
